import { render, staticRenderFns } from "./PagoEfectivo.vue?vue&type=template&id=566c2884&scoped=true"
import script from "./PagoEfectivo.vue?vue&type=script&lang=ts"
export * from "./PagoEfectivo.vue?vue&type=script&lang=ts"
import style0 from "./PagoEfectivo.vue?vue&type=style&index=0&id=566c2884&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c2884",
  null
  
)

export default component.exports